import { Injectable } from "@angular/core";
import { Title } from "@angular/platform-browser";
import * as $ from "jquery";
import * as color from "./../../../assets/styles/colors/partner-colors.json";
import { IPartnerDetail } from "../interface/partner.interface";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { firstValueFrom } from "rxjs";

interface PartnerListAttributesInterface {
  code: string;
  title: string;
  hostName: string[];
  gtmID: string;
  uniquePageViews: boolean;
  takaful: boolean;
}

@Injectable({
  providedIn: "root"
})
export class PartnerService {
  colorObject = (color as any).default;

  psHostName: string[] = [
    "motor.policystreet.com",
    "motor.policystreet.app",
    "car.policystreet.com",
    "car.policystreet.app",
    "uat-car.policystreet.app",
    "localhost"
  ];
  partnerList: PartnerListAttributesInterface[] = [
    {
      code: "foodpanda",
      title: "foodpanda | Motorbike Insurance",
      hostName: [
        "foodpanda.policystreet.app",
        "foodpanda.policystreet.com",
        "bike.foodpanda.policystreet.com"
      ],
      gtmID: "",
      uniquePageViews: false,
      takaful: false
    },
    {
      code: "lalamove",
      title: "Lalamove | Auto Insurance",
      hostName: ["lalamove.policystreet.app", "lalamove.policystreet.com"],
      gtmID: "",
      uniquePageViews: false,
      takaful: false
    },
    {
      code: "ctos",
      title: "CTOS | Car Insurance",
      hostName: ["ctos.policystreet.com", "ctos.policystreet.app"],
      gtmID: "GTM-MRN9J57",
      uniquePageViews: true,
      takaful: false
    },
    {
      code: "carsome",
      title: "Carsome | Car Insurance",
      hostName: [
        "carsome-v2.policystreet.com",
        "carsome.policystreet.com",
        "carsome.policystreet.app"
      ],
      gtmID: "",
      uniquePageViews: false,
      takaful: false
    },
    {
      code: "carsomereferral",
      title: "Carsome Referral | Car Insurance",
      hostName: [
        "carsomereferral.policystreet.com",
        "carsomereferral.policystreet.app"
      ],
      gtmID: "",
      uniquePageViews: false,
      takaful: false
    },
    {
      code: "carsometelemarketing",
      title: "Carsome | Car Insurance",
      hostName: [
        "carsometelemarketing.policystreet.com",
        "carsometelemarketing.policystreet.app"
      ],
      gtmID: "",
      uniquePageViews: false,
      takaful: false
    },
    {
      code: "cbp",
      title: "Co-opbank Pertama | Car Insurance",
      hostName: ["cbp.policystreet.app", "cbp.policystreet.com"],
      gtmID: "",
      uniquePageViews: false,
      takaful: true
    },
    {
      code: "wapcar",
      title: "Wapcar | Car Insurance",
      hostName: ["wapcar.policystreet.app", "wapcar.policystreet.com"],
      gtmID: "",
      uniquePageViews: false,
      takaful: false
    },
    {
      code: "mytukarInsure",
      title: "myTukar | Car Insurance",
      hostName: [
        "mytukarinsure.policystreet.app",
        "mytukarinsure.policystreet.com"
      ],
      gtmID: "",
      uniquePageViews: false,
      takaful: false
    },
    {
      code: "grab",
      title: "Grab | Auto Insurance",
      hostName: [
        "grab-v2.policystreet.com",
        "grab.policystreet.app",
        "grab.policystreet.com"
      ],
      gtmID: "",
      uniquePageViews: false,
      takaful: false
    },
    {
      code: "airasia",
      title: "Airasia | Car Insurance",
      hostName: [
        "airasia-v2.policystreet.com",
        "airasia.policystreet.app",
        "airasia.policystreet.com"
      ],
      gtmID: "",
      uniquePageViews: false,
      takaful: false
    },
    {
      code: "airasiaride",
      title: "Airasia Ride | Car Insurance",
      hostName: [
        "airasiaride.policystreet.com",
        "airasiaride.policystreet.app"
      ],
      gtmID: "",
      uniquePageViews: false,
      takaful: false
    },
    {
      code: "mahsing",
      title: "Mahsing | Car Insurance",
      hostName: [
        "mahsing-v2.policystreet.com",
        "mahsing.policystreet.app",
        "mahsing.policystreet.com"
      ],
      gtmID: "",
      uniquePageViews: false,
      takaful: false
    },
    {
      code: "bonuslink",
      title: "Bonuslink | Car Insurance",
      hostName: [
        "bonuslink-v2.policystreet.com",
        "bonuslink.policystreet.app",
        "bonuslink.policystreet.com"
      ],
      gtmID: "",
      uniquePageViews: false,
      takaful: false
    },
    {
      code: "carlist",
      title: "Carlist | Car Insurance",
      hostName: [
        "carlist-v2.policystreet.com",
        "carlist.policyreet.app",
        "carlist.policystreet.com"
      ],
      gtmID: "",
      uniquePageViews: false,
      takaful: false
    },
    {
      code: "ktmb",
      title: "KTMB | Car Insurance",
      hostName: ["ktmb.policystreet.app", "ktmb.policystreet.com"],
      gtmID: "",
      uniquePageViews: false,
      takaful: false
    },
    {
      code: "prolindung",
      title: "PROLINDUNG | Car Insurance",
      hostName: ["prolindung.policystreet.app", "prolindung.policystreet.com"],
      gtmID: "",
      uniquePageViews: false,
      takaful: false
    }
  ];
  partnerDetail: IPartnerDetail;
  constructor(private titleService: Title, private http: HttpClient) {}

  private partnerCodePromise: Promise<string> | null = null;
  private resolvedPartnerCode: string | null = null;

  mmRef: string | null = null;

  private basePath: string = `${environment.url}/api/Motor/`;

  async getPartnerByCode(code: string): Promise<IPartnerDetail> {
    return await firstValueFrom(
      this.http.get<IPartnerDetail>(
        `${this.basePath}GetPartnerDetailByCode?partnerCode=${code}`
      )
    );
  }

  async getPartnerCode(): Promise<string> {
    // If already resolved, return immediately
    if (this.resolvedPartnerCode) {
      return this.resolvedPartnerCode;
    }

    // If already in progress, return same promise
    if (this.partnerCodePromise) {
      return this.partnerCodePromise;
    }

    // Otherwise, create the promise ONCE
    this.partnerCodePromise = (async () => {
      let hostName = window.location.hostname.toLowerCase();
      const parts = hostName.split(".");

      const knownPrefixes = ["bike", "car"];
      let subdomain = parts[0];

      if (knownPrefixes.includes(parts[0]) && parts.length > 2) {
        subdomain = parts[1];
      }

      let urlParams = new URLSearchParams(window.location.search);
      let partnerCode = urlParams.get("partnerCode");

      if (partnerCode == "moneymama") {
        this.mmRef = urlParams.get("mm_ref");
      }

      if (
        !partnerCode &&
        hostName &&
        !this.psHostName.some((x) => x.toLowerCase() === hostName)
      ) {
        try {
          this.partnerDetail = await this.getPartnerByCode(subdomain);

          if (this.partnerDetail?.hostName) {
            const hostList = this.partnerDetail.hostName
              .split(",")
              .map((h) => h.trim().toLowerCase());

            if (hostList.includes(hostName)) {
              partnerCode = this.partnerDetail.code;
            }
          }
        } catch (error) {
          console.error("Failed to load partner detail:", error);
        }
      }

      if (partnerCode) {
        try {
          this.partnerDetail = await this.getPartnerByCode(partnerCode);

          if (this.partnerDetail?.title) {
            this.titleService.setTitle(this.partnerDetail.title);
          }
        } catch (error) {
          console.error("Failed to load partner detail:", error);
        }
      } else {
        const colorPartnerCode = "default";
        const colorList = this.colorObject[colorPartnerCode];
        colorList.forEach((x: { root: string; value: string }) => {
          document.documentElement.style.setProperty(x.root, x.value);
        });
      }

      // ✅ Cache final value
      this.resolvedPartnerCode = partnerCode;
      return partnerCode;
    })();

    return this.partnerCodePromise;
  }

  getPartnerIdentityTypeByCode(code: string) {
    return this.http.get(
      `${this.basePath}GetPartnerIdentityTypeByCode?partnerCode=${code}`
    );
  }

  getPartnerAttribute(partnerCode: string, type: string) {
    let partner = this.partnerList.find((x) => x[type] == true);
    if (partner.code == partnerCode) return true;
    else return false;
  }

  setPartnerAttribute(
    partnerCode: string,
    type: string,
    value: boolean | string
  ) {
    let partner = this.partnerList.find((x) => x[partnerCode] === x.code);
    if (partner) {
      partner[type] = value;
    }
  }

  appendGtmScript(gtmCode: string) {
    var headScript = `<script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                    })(window,document,'script','dataLayer','${gtmCode}');</script>`;
    var bodyScript = `<noscript><iframe src="https://www.googletagmanager.com/ns.html?id=${gtmCode}"
    height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>`;
    this.appendHeaderScript(headScript);
    this.appendBodyScript(bodyScript);
  }

  appendHeaderScript(script: string) {
    $("head").append(script);
  }

  appendBodyScript(script: string) {
    $("body").append(script);
  }
}
